'use strict';
var analysisPanelTpl = require('./panel.html');
var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["VuFactory", function (VuFactory) {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            ngShow: '=',
            trainData: '=',
            options: '='
        },
        template: analysisPanelTpl,
        link: function (scope, element, attrs) {
            "use strict";

            scope.selected = {
                discriminator: undefined,
                subDiscriminator: undefined,
                allDiscriminators: false,
                allSubDiscriminators: false,
                rate: 1,
                useRate: false,
                previousProperty: undefined
            };
            scope.applied = false;
            scope.vuSites = {};
            VuFactory.getVuMessageData(undefined, scope.trainData, function (data) {
                scope.vuSites = VuFactory.getParsedUrls(data);
            });

            scope.$watch(function () {
                return  scope.ngModel.getCurrentState().messageName === scope.selected.messageName;
            }, function () {
                scope.selected.allSubDiscriminators = false;
                scope.selected.allDiscriminators = false;

                if (scope.ngModel.hasSubDiscriminator()) {
                    scope.selected.subDiscriminator = scope.ngModel.getSubDiscriminator();
                }
                if(scope.ngModel.hasDiscriminator()){
                    scope.selected.discriminator = scope.ngModel.getDiscriminator();
                }
                scope.selected.rate = scope.ngModel.getRate();
                scope.selected.useRate = scope.ngModel.getUseRate();
                scope.selected.aggregateVlinks = scope.ngModel.isVlinkAggregationEnabled();
                scope.selected.shouldAggregateVlinks = scope.ngModel.shouldAggregateVlinks();

                if (scope.selected.useRate) {
                    setRateClass(scope.selected.rate);
                }
            });

            var setRateClass = function (rate) {
                if (rate < 1) {
                    scope.rateClass = "danger";
                } else if (rate > 59) {
                    scope.rateClass = "success";
                } else {
                    scope.rateClass = "warning";
                }
            };

            scope.setRate = function (rate) {
                scope.ngModel.setRate(rate);
                setRateClass(scope.selected.rate);
            };

            scope.hidePanel = function () {
                scope.ngShow = false;
            };

            scope.checkProperty = function (property) {
                // just to be sure, check the property
                if (util.isDefined(scope.selected.previousProperty)) {
                    scope.selected.previousProperty.checked = false;
                }
                property.checked = true;
                scope.selected.previousProperty = property;
                scope.ngModel.setEnableApply();
            };

            scope.exportKmlFile = function () {
                scope.$emit('exportKml');
            };

            scope.apply = function () {
                scope.$emit('apply');
                scope.applied = true;
            };
        }
    };
}];